import React from 'react';
import PersonalHero from './sections/PersonalHero/PersonalHero';
import CharacterWorld from './sections/CharacterWorld/characterWorld/CharacterWorld';
import CompetitionStatus from './sections/CompetitionStatus/CompetitionStatus';
import ContestInfo from './sections/ContestInfo/ContestInfo';
import Scoreboard from './sections/Scoreboard/Scoreboard';
import PromoBlock from './sections/ContestInfo/blocks/promoBlock/PromoBlock';
import FinalSection from './sections/FinalSection/FinalSection';

const sectionRegistry = {
  PersonalHero,
  CharacterWorld,
  CompetitionStatus,
  ContestInfo,
  Scoreboard,
  PromoBlock,
  FinalSection,
};

const SectionRenderer = ({ section }) => {

  const Component = sectionRegistry[section.type];
  if (!Component) {
    return null;
  }

  return (
    <div id={section.anchorId} className="section-container">
      <Component {...section.props} />
    </div>
  );
};

export default SectionRenderer;

